import { useTranslation } from 'react-i18next';
import { useView, ViewEnum } from '@shared/hooks';
import { cn, PaletteUtils } from '@shared/utils';
import { CardsTable, TransactionsTable } from '@widgets';
import { Button, Icon, PageContainer } from '@shared/widgets';
import GridViewIcon from '@assets/icons/grid-view.svg';
import LineViewIcon from '@assets/icons/line-view.svg';

export const CardsPage = () => {
  const viewState = useView({ page: 'cards' });

  const { t } = useTranslation('cards');

  return (
    <PageContainer
      title={t('title')}
      header={t('header')}
      topRightAddons={
        <>
          <Button
            className={cn('h-10 w-10 rounded-sm', PaletteUtils.isVcfcPalette && 'bg-light/10', 'hover:bg-light/60 dark:hover:bg-light/30')}
            color='icon'
            onClick={() => viewState.onChangeView(ViewEnum.Grid)}
          >
            <Icon
              className={cn(
                viewState.isGrid && PaletteUtils.isInsigniaPalette && 'text-primary',
                PaletteUtils.isVcfcPalette && viewState.isGrid ? 'text-primary dark:text-white' : 'dark:text-white/50',
              )}
              icon={<GridViewIcon />}
            />
          </Button>
          <Button
            className={cn('ml-4 h-10 w-10 rounded-sm', PaletteUtils.isVcfcPalette && 'bg-light/10', 'hover:bg-light/60 dark:hover:bg-light/30')}
            color='icon'
            onClick={() => viewState.onChangeView(ViewEnum.List)}
          >
            <Icon
              className={cn(
                viewState.isList && PaletteUtils.isInsigniaPalette && 'text-primary',
                PaletteUtils.isVcfcPalette && viewState.isList ? 'text-primary dark:text-white' : 'dark:text-white/50',
              )}
              icon={<LineViewIcon />}
            />
          </Button>
        </>
      }
    >
      <div
        className={cn(PaletteUtils.isVcfcPalette && 'mb-6 rounded-xl bg-white dark:rounded-xl dark:border dark:border-gray-black dark:bg-soft-black')}
      >
        <CardsTable listType={viewState.isList} />
      </div>
      <TransactionsTable className={cn(PaletteUtils.isVcfcPalette && 'dark:rounded-xl dark:border dark:border-gray-black')} />
    </PageContainer>
  );
};
